<template>
  <section class="form-surface">
    <form class="form-panel" @submit.prevent="requestReset">
      <h1>Forgot password</h1>
      <div v-if="message" class="workspace-alert">{{ message }}</div>
      <label class="form-row">
        <span>Email</span>
        <input v-model="email" type="email" autocomplete="email" />
      </label>
      <button type="submit">Send reset link</button>
      <div class="form-actions muted-actions">
        <RouterLink class="app-link" to="/login">Back to login</RouterLink>
      </div>
    </form>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { RouterLink } from 'vue-router';
import { CommandsService } from '../api/generated';
import { getErrorMessage } from '../stores/session';
import { validateRequiredEmail } from '../validation/userValidation';

const email = ref('');
const message = ref<string | null>(null);

async function requestReset(): Promise<void> {
  const validationMessage = validateRequiredEmail(email.value);
  if (validationMessage != null) {
    message.value = validationMessage;
    return;
  }

  try {
    await CommandsService.commandRequestPasswordResetCommand({ requestBody: { email: email.value.trim() } });
    message.value = 'If that email is verified, a reset link has been sent.';
  } catch (error) {
    message.value = getErrorMessage(error, 'Unable to request password reset.');
  }
}
</script>
